// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import { memo } from 'react'
import { ImageItem, VideoItem } from '../items'
import styles from '../../Canvas.module.css'
import type { Rect } from './types'

interface PreviewOverlayProps {
    visible: boolean
    previewSrc: string | null
    previewMediaType?: string
    previewRect: Rect | null
    captionText: string | null
    captionRect: Rect | null
    onImageLoad: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void
    onVideoLoad?: (e: React.SyntheticEvent<HTMLVideoElement, Event>) => void
    onImageError: () => void
}

export const PreviewOverlay = memo(function PreviewOverlay(props: PreviewOverlayProps): ReactElement {
    const { visible, previewSrc, previewMediaType, previewRect, captionText, captionRect, onImageLoad, onVideoLoad, onImageError } = props

    return (
        <div className={styles.previewOverlay + (visible ? ' ' + styles.previewOverlayVisible : '')}>
            {previewSrc && (
                previewMediaType === 'video' ? (
                    <VideoItem
                        key={previewSrc}
                        src={previewSrc}
                        rect={previewRect || undefined}
                        autoPlay
                        playOnHover={false}
                        onLoadedMetadata={onVideoLoad}
                        onError={onImageError}
                    />
                ) : (
                    <ImageItem
                        key={previewSrc}
                        src={previewSrc}
                        rect={previewRect || undefined}
                        onLoad={onImageLoad}
                        onError={onImageError}
                    />
                )
            )}
            {previewSrc && previewRect && captionText && captionRect && (
                <div
                    className={styles.previewCaption}
                    style={{
                        top: captionRect.y,
                        left: captionRect.x,
                        width: captionRect.w,
                        maxHeight: captionRect.h,
                    }}
                >
                    {captionText}
                </div>
            )}
        </div>
    )
})

